// JsFromRoutes CacheKey 7cd318d53a83f0e6c8b01aed9a40fbfd
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  generatePublicLink: definePathHelper('get', '/api/years/:year_id/championship_teams/:id/generate_public_link'),
  openChallenges: definePathHelper('get', '/api/years/:year_id/championship_teams/:id/open_challenges'),
  clearExistingSubmission: definePathHelper('delete', '/api/years/:year_id/championship_teams/:id/clear_existing_submission'),
  updateTeams: definePathHelper('post', '/api/years/:year_id/championship_teams/update_teams'),
  contactInfo: definePathHelper('get', '/api/years/:year_id/championship_teams/contact_info'),
  get: definePathHelper('get', '/api/years/:year_id/championship_teams/:id'),
  update: definePathHelper('patch', '/api/years/:year_id/championship_teams/:id'),
}
